import { useQuery, useZero } from "@rocicorp/zero/react";
import { useMemo } from "react";
import { sharedMutators } from "../../../shared/mutators";
import { queries } from "../../../shared/queries";
import { liveWorkflows } from "../../lib/connector";
import { pluralize } from "../../lib/inflection";
import { Button } from "../Button";
import { Text } from "../Text";
import { WorkflowPreviewList } from "../WorkflowPreviewList";
import { ModalContent, ModalFooter } from "../ModalCard";

export function DeleteConnectorModalBody({
  appId,
  onClose,
  onDeleted,
}: {
  appId: string;
  onClose: () => void;
  onDeleted?: () => void;
}) {
  const z = useZero();
  const [usageRows] = useQuery(
    queries.connectorUsageDetails({ connectedAppId: appId })
  );
  const workflows = useMemo(() => liveWorkflows(usageRows), [usageRows]);
  const published = workflows.filter((w) => !w.draft);
  const drafts = workflows.filter((w) => w.draft);
  const parts: string[] = [];
  if (published.length > 0)
    parts.push(
      `${published.length} ${pluralize("workflow", published.length)}`
    );
  if (drafts.length > 0)
    parts.push(`${drafts.length} ${pluralize("branch", drafts.length)}`);

  return (
    <ModalContent style={{ width: 320 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <Text variant="text-regular-md" color="var(--text-primary)">
          Delete connector
        </Text>
        {workflows.length === 0 ? (
          <Text variant="text-regular" color="var(--text-secondary)">
            Permanently deletes this connector and its configuration.
          </Text>
        ) : (
          <Text variant="text-regular" color="var(--text-secondary)">
            Used by {parts.join(" and ")}. Deleting removes the connector, so
            any steps that use it will need a replacement.
          </Text>
        )}
      </div>
      <WorkflowPreviewList workflows={workflows} />
      <ModalFooter>
        <Button size="l" variant="subtle" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="l"
          variant="danger"
          onClick={() => {
            z.mutate(
              sharedMutators.deleteConnectedApp({ connectedAppId: appId })
            );
            onDeleted?.();
            onClose();
          }}
        >
          Delete connector
        </Button>
      </ModalFooter>
    </ModalContent>
  );
}
